<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadMessageHistories(1, null, true)">

      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download"  @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :placeholder="$tc('message', 2)" v-model="messageSearchParams.message" class="w-full mb-3"/>
          <vs-input :placeholder="$t('agent')" v-model="messageSearchParams.agent" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :placeholder="$t('sender')" v-model="messageSearchParams.sender" class="w-full mb-3"/>
          <vs-input :placeholder="$t('receiver')" v-model="messageSearchParams.receiver" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
<!--          <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('result')" v-model="messageSearchParams.result" class="mb-3" />-->
          <select v-model="messageSearchParams.result" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('result') }}</option>
            <option v-for="(option, key) in resultOptions" :key="'result_' + key" :value="option.value">{{ option.label }}</option>
          </select>
<!--          <v-select :options="typeOptions" :reduce="label => label.value" :placeholder="$t('type')" v-model="messageSearchParams.type" />-->
          <select v-model="messageSearchParams.type" class="vs-inputx vs-input--input normal" style="width:100%;" >
            <option value="">{{ $t('type') }}</option>
            <option v-for="(option, key) in typeOptions" :key="'type_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadMessageHistories(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="messageHistoryDataContainer" :title="$t('history')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-messages-tab-nav></shared-messages-tab-nav>
      </template>

      <shared-messages-history-list :messages="messages"></shared-messages-history-list>

      <template slot="footer">
        <paginate
          :total="messagePages"
          :itemPerPage="itemPerPage"
          :click-handler="loadMessageHistories"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedMessagesTabNav from '@/views/Shared/Messages/TabNav'
import History from '@/models/History'
import Pagination from '@/mixins/paginate'
import Paginate from '@/components/Paginate'
import SharedMessagesHistoryList from '@/views/Shared/Messages/History/List'

export default {
  name: 'User.Messages.History',
  mixins: [Pagination],
  components: {
    SharedMessagesTabNav,
    Paginate,
    SharedMessagesHistoryList
  },
  data () {
    return {
      messages: {},
      messagePages: 1,
      itemPerPage: null,
      messageSearchParams: {
        message: typeof this.$route.query.message !== 'undefined' ? this.$route.query.message : '',
        sender: typeof this.$route.query.sender !== 'undefined' ? this.$route.query.sender : '',
        result: typeof this.$route.query.result !== 'undefined' ? this.$route.query.result : '',
        agent: typeof this.$route.query.agent !== 'undefined' ? this.$route.query.agent : '',
        receiver: typeof this.$route.query.receiver !== 'undefined' ? this.$route.query.receiver : '',
        type: typeof this.$route.query.type !== 'undefined' ? this.$route.query.type : ''
      },
      resultOptions: [],
      typeOptions: [],
      companyId: this.$store.getters.userInfo.company.id
    }
  },
  mounted () {
    this.loadMessageHistories(this.initialPage, null)
  },
  methods: {
    async loadMessageHistories (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#messageHistoryDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      this.$router.replace({ query: { ...this.messageSearchParams, page, itemPerPage } })
      const response = await History.all({ ...this.messageSearchParams, page, itemPerPage })
      this.messages = response.data.data.messages
      this.messagePages = response.data.meta.pagination.last_page
      this.typeOptions = response.data.meta.options.types
      this.resultOptions = this.parseResult(response.data.meta.options.results)
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#messageHistoryDataContainer > .con-vs-loading')
    },
    parseResult (resultResponse) {
      return resultResponse.map((val) => {
        return {
          label: this.$t(`code_${  val.label}`),
          value: String(val.value)
        }
      })
    },
    async exportData (e) {
      e.preventDefault()
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await History.export({...this.messageSearchParams, companyId: this.companyId, language, export: true})
      } catch (e) {
        this.$alertHelper.error()
      }
    }
  }
}
</script>

<style scoped>

</style>
